import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";
import { setCesiumMode } from "./cesiumSlice";
import { INSPECT_ALL_IMAGES } from "~/components/CesiumToolBar/constants";
import { setAsset } from "./assetSlice";
import { DATA, REPORTS, INSPECTION, INFO, ASSET_ID, SPANS, INSPECTIONS, ANNOTATIONS, 
  SURVEYS, FOLDER, IMAGES_MODULE, IMAGE_WITH_MEASUREMENTS, BRIDGE_FORM, TASKS, ELEMENTS,
   AI_DB, FIND_EPSG ,FOLDER_TREE,
   DEFECT_RATING,
   ASSET_VERTICAL_FIELDS,
   SURVEY_VERTICAL_FIELDS} from "~/components/cesiumComponents/constants";
import type { CALIBRATE_MODELS, DEFECTS_ANALYSIS, ELEMENTS_ALLOCATION, GENERATE_REPORTS, LOGS, UPLOAD_IMAGES_CSV } from "./constants";
import { fetchSurvey } from "~/thunks/surveyThunks";


export type SetComponentPayload = {
  component: keyof ComponentAllocatorState;
  value: TComponentName | null;
};
export type TComponentName =
  typeof DATA |
  typeof REPORTS |
  typeof INSPECTION |
  typeof INFO |
  typeof ASSET_ID |
  typeof SPANS |
  typeof INSPECTIONS |
  typeof ANNOTATIONS |
  typeof ASSET_VERTICAL_FIELDS |
  typeof SURVEY_VERTICAL_FIELDS |
  typeof AI_DB |
  typeof SURVEYS |
  typeof DEFECT_RATING |
  typeof FOLDER |
  typeof IMAGES_MODULE |
  typeof IMAGE_WITH_MEASUREMENTS |
  typeof BRIDGE_FORM |
  typeof TASKS |
  typeof LOGS |
  typeof CALIBRATE_MODELS |
  typeof FOLDER_TREE |
  typeof FIND_EPSG |
  typeof UPLOAD_IMAGES_CSV |
  typeof ELEMENTS_ALLOCATION |
  typeof GENERATE_REPORTS |
  typeof DEFECTS_ANALYSIS |
  typeof ELEMENTS;
interface ComponentAllocatorState {
  inspectionsTab: TComponentName;
  infoTab: TComponentName;
  surveysTab: TComponentName;
  bottomView: TComponentName | null;
  rightView: TComponentName | null;
  mainViewOverlay: TComponentName | null;
  tasksTabOverlay: TComponentName | null;
  spansTabOverlay: TComponentName | null;
  leftView: TComponentName | null; 
  cesiumToolBar: TComponentName | null;

};

const initialState: ComponentAllocatorState = {
  inspectionsTab: REPORTS,
  infoTab: INFO,
  surveysTab: INSPECTIONS,
  bottomView: null,
  rightView: null,
  leftView: INFO,
  mainViewOverlay: null,
  tasksTabOverlay: null,
  spansTabOverlay: null,
  cesiumToolBar: null,
};

const componentSlice = createSlice({
  name: "componentAllocator",
  initialState,
  reducers: {
    setComponent: (state, action: PayloadAction<SetComponentPayload | SetComponentPayload[]>) => {
      console.log("setComponent", action.payload);
      if (Array.isArray(action.payload)) {
        action.payload.forEach(payload => {
          if (payload.component == "mainViewOverlay" && payload.value === null && state.mainViewOverlay === REPORTS) {
            state.rightView = IMAGES_MODULE

          }
          (state as any)[payload.component] = payload.value;
        });
      } else {
        if (action.payload.component == "mainViewOverlay" && action.payload.value === null && state.mainViewOverlay === REPORTS) {
          state.rightView = IMAGES_MODULE;
          state.bottomView = ANNOTATIONS;

        }
        (state as any)[action.payload.component] = action.payload.value;
      }
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(setCesiumMode, (state, action: PayloadAction<string[] | null>) => {
        console.log("setCesiumMode", action.payload);
        if (action.payload?.includes(INSPECT_ALL_IMAGES)) {
          state.rightView = IMAGES_MODULE;
        }
      })
    .addCase(fetchSurvey.pending, (state, action: PayloadAction<any | null>) => {
      console.log("COMPONENT_ALLOCATOR_SLICE - fetchSurvey.pending", action.payload);
      Object.assign(state, initialState);
    })
    .addCase(setAsset, (state, action: PayloadAction<any | null>) => {
      console.log("COMPONENT_ALLOCATOR_SLICE - setAsset", action.payload);
      Object.assign(state, initialState);
    })
  },
});

export const {
  setComponent,

} = componentSlice.actions;
export const selectComponentAllocator = (state: any) => state.componentAllocator;
export default componentSlice.reducer;
export const selectInspectionsTab = (state: any) => state.componentAllocator.inspectionsTab;
export const selectInfoTabSelectedTab = (state: any) => state.componentAllocator.infoTab;
export const selectSurveysTabSelectedTab = (state: any) => state.componentAllocator.surveysTab;
export const selectBottomViewComponent = (state: any) => state.componentAllocator.bottomView;
export const selectRightViewComponent = (state: any) => state.componentAllocator.rightView;
export const selectLeftViewComponent = (state: any) => state.componentAllocator.leftView;
export const selectMainViewOverlayComponent = (state: any) => state.componentAllocator.mainViewOverlay;
export const selectTasksTabOverlayComponent = (state: any) => state.componentAllocator.tasksTabOverlay;
export const selectCesiumToolBarComponent = (state: any) => state.componentAllocator.cesiumToolBar;
export const selectSpansTabOverlayComponent = (state: any) => state.componentAllocator.spansTabOverlay;